import React, { useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { WizardProvider } from './context/WizardContext';
import Wizard from './components/Wizard';
import AdminLogin from './components/admin/AdminLogin';
import AdminProtectedRoute from './components/admin/ProtectedRoute';
import IncompleteFormsView from './components/admin/IncompleteFormsView';
import CompletedFormsView from './components/admin/CompletedFormsView';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { VERSION } from './utils/version';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const App: React.FC = () => {
  useEffect(() => {
    console.log('Retirement Wizard Version:', VERSION);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}>
        <WizardProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Navigate to="/wizard" replace />} />
            <Route path="/wizard" element={<Wizard />} />
            <Route path="/wizard/:idCustomer" element={<Wizard />} />

            {/* Legacy Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/incomplete-forms" element={
              <AdminProtectedRoute>
                <IncompleteFormsView />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/completed-forms" element={
              <AdminProtectedRoute>
                <CompletedFormsView />
              </AdminProtectedRoute>
            } />
          </Routes>
        </WizardProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
